import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { MessageCircle, Camera, ChevronRight } from 'lucide-react';
import { t } from '../../lib/i18n';

const formatDate = (value, language) => new Date(value).toLocaleDateString(
  language === 'fr' ? 'fr-FR' : 'en-US',
  { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' },
);

const SessionRow = ({ session, language, onOpen }) => (
  <button
    data-testid={`dashboard-session-${session.session_id}`}
    onClick={() => onOpen(session.session_id)}
    className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-white/5 transition-colors duration-200 text-left"
  >
    <div className="p-2 rounded-lg bg-lux-gold/10">
      {session.has_photo
        ? <Camera className="w-4 h-4 text-[var(--lux-gold)]" />
        : <MessageCircle className="w-4 h-4 text-[var(--lux-gold)]" />}
    </div>
    <div className="flex-1 min-w-0">
      <p className="text-sm text-white truncate">{session.title}</p>
      <p className="text-xs text-white/30">{formatDate(session.updated_at, language)}</p>
    </div>
    <ChevronRight className="w-4 h-4 text-white/20" />
  </button>
);

export const RecentSessions = ({ sessions = [], language, onOpen, onViewAll }) => (
  <Card className="bg-lux-panel/90 border-white/[0.08] fade-in" data-testid="dashboard-recent-sessions">
    <CardHeader className="pb-3">
      <div className="flex items-center justify-between">
        <CardTitle className="text-lg font-display text-white">{t('recentSessions', language)}</CardTitle>
        <Button data-testid="dashboard-view-all-sessions" variant="ghost" onClick={onViewAll} className="text-xs text-white/40 hover:text-white/70">
          {language === 'fr' ? 'Voir tout' : 'View all'} <ChevronRight className="w-3 h-3 ml-1" />
        </Button>
      </div>
    </CardHeader>
    <CardContent>
      {sessions.length > 0 ? (
        <div className="space-y-2">
          {sessions.map(session => (
            <SessionRow key={session.session_id} session={session} language={language} onOpen={onOpen} />
          ))}
        </div>
      ) : (
        <div className="text-center py-8" data-testid="dashboard-no-sessions">
          <MessageCircle className="w-8 h-8 text-white/10 mx-auto mb-3" />
          <p className="text-white/30 text-sm">{t('noSessions', language)}</p>
        </div>
      )}
    </CardContent>
  </Card>
);
